import { useRef, useEffect } from 'react';

/**
 * If `value` changes (shallow equality), returns the previous value of `value`.
 *
 * Typical usage:
 *
 * ```ts
 * const [value, setValue] = useState("foo");
 * const previousValue = useLatest(value);
 * ```
 * If we call `setValue("bar")`, `previousValue` will be `"foo"`.
 *
 * The initial value of `previousValue` is `undefined`.
 */
export const useLatest = <T>(value: T) => {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};
